export default {
      id: "close-new-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#close-new",
      toString: function () {
        return this.url;
      }
    }